import getSearchParams from './getSearchParams';
import get from 'lodash/get';

const getSearchParam = (search: string, name: string) => get(getSearchParams(search), name);

export default getSearchParam;
